export default __webpack_public_path__ + "static/media/EAST1060.34I-34188_-18435_0.09be03d8.jpg";